// removed by extract-text-webpack-plugin
module.exports = {"NavigationItem":"NavigationItem__NavigationItem__3muAB","active":"NavigationItem__active__MCx74"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Navigation/NavigationItems/NavigationItem/NavigationItem.css
// module id = 30
// module chunks = 0